import React from "react";
import { new_history_image, old_history_image } from "../Constants/Data";
import { IoPlayCircle } from "react-icons/io5";

function AboutHistory() {
  return (
    <section className="py-[120px] bg-white relative font-Rubik overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">

        {/* Header Section */}
        <div className="text-center mb-16 max-w-screen-lg mx-auto">
          <h3 className="text-primary font-Urbanist font-bold text-2xl md:text-4xl lg:text-5xl leading-tight mb-4">
            The Heritage of Excellence
          </h3>
          <h4 className="text-gray-800 font-Urbanist font-medium text-xl md:text-3xl">
            Cricket at St. John’s College, Jaffna
          </h4>
        </div>

        <div className="flex flex-col gap-24">

          {/* History Section */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1 relative group">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={old_history_image}
                  alt="St. John's College Cricket History"
                  className="w-full h-[400px] lg:h-[500px] object-cover transform group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60"></div>
              </div>
            </div>

            <div className="order-1 lg:order-2 flex flex-col gap-6 text-gray-700 text-lg leading-relaxed font-light text-justify">
              <p>
                With a legacy spanning over two centuries, St. John’s College, Jaffna, upholds a
                cricketing tradition defined by resilience, discipline, and a pursuit of excellence.
                Since its establishment in 1823, the College has been dedicated to the holistic
                development of its students, viewing the cricket field as an essential classroom
                for character. Here, the "gentleman’s game" is more than a sport; it is a vehicle for
                instilling the integrity and social grace necessary to mold young students into men
                of great stature and leadership.
              </p>
              <p>
                For over a hundred years, St. John’s has been a cornerstone of Northern cricket, most
                notably through the "Battle of the North"—the peninsula’s oldest and most revered sporting
                rivalry. This historic encounter stands as a testament to the College’s enduring spirit,
                having prevailed through decades of unprecedented regional challenges to remain a symbol of
                unity and excellence.
              </p>
              <p>
                Today, St. John’s College continues to set the benchmark for school cricket by balancing a
                respect for its historic roots with a modern approach to athletic development. We take pride
                in producing eminent citizens who carry the lessons of teamwork and perseverance into every
                facet of academia and business.
              </p>
            </div>
          </div>

          {/* Vision & Mission Section */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-1 flex flex-col gap-8">
              {/* Vision */}
              <div className="bg-gray-50 p-8 rounded-2xl border-l-4 border-primary shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <IoPlayCircle className="text-primary text-4xl" />
                  <h4 className="font-Urbanist font-bold text-2xl text-gray-900">OUR VISION</h4>
                </div>
                <p className="text-gray-700 leading-relaxed text-lg font-light">
                  To create an ethos for students to attain excellence spiritually, academically, morally and socially
                </p>
              </div>

              {/* Mission */}
              <div className="bg-gray-50 p-8 rounded-2xl border-l-4 border-primary shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <IoPlayCircle className="text-primary text-4xl" />
                  <h4 className="font-Urbanist font-bold text-2xl text-gray-900">OUR MISSION</h4>
                </div>
                <p className="text-gray-700 leading-relaxed text-lg font-light">
                  St. John's College, Jaffna, carries out its mission by aspiring to be a "haven for children 
                  from every walk of life," transcending social norms to transform young students into men of 
                  stature and integrity. Rooted in its 200-year history and founded on Christian values, the 
                  college focuses on imparting a comprehensive education that balances rigorous academic 
                  standards with a wide array of co-curricular activities and the inculcation of strong 
                  discipline. By fostering this holistic environment, the institution aims to nurture 
                  eminent global citizens who can excel spiritually, academically, and socially while 
                  embodying the school's motto, "Light shineth in darkness". 
                </p>
              </div>
            </div>

            <div className="order-2 relative group">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={new_history_image}
                  alt="Our Vision and Mission"
                  className="w-full h-[500px] object-cover transform group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default AboutHistory;
